import { ProductType } from '@/api/Cart/cart.interfaces';
import {
    convertToDate,
    getDifferenceInYears,
    getShortDate,
} from '@shared/helpers/datetime/datetime';
import {
    AgeRange,
    AgeRangeDefinitions,
    AgeRanges,
    PassengerType,
} from '@/api/Checkout/checkout.interfaces';
import { isNil } from 'lodash';

export interface DateValueObject {
    day: string | undefined;
    month: string | undefined;
    year: string | undefined;
}

const getConfig = (pax: AgeRanges, age: number): AgeRange =>
    Object.values(pax).find(({ Min, Max }) => age >= Min && age <= Max);

export const getAgeConfigByProduct = (
    ageDefinitions: AgeRangeDefinitions,
    type: ProductType,
    age?: number | null
): AgeRange => {
    const defaultConfig: AgeRange = {
        Min: 0,
        Max: 120,
        Type: PassengerType.Adult,
    };
    const hotelConfig: AgeRange = {
        Min: 18,
        Max: 120,
        Type: PassengerType.Adult,
    };

    if (!isNil(age)) {
        switch (type) {
            case ProductType.Flight:
                return getConfig(ageDefinitions.Flight, age);
            case ProductType.Ferry:
                return getConfig(ageDefinitions.Ferry, age);
            case ProductType.Hotel:
                return hotelConfig;
            default:
                return defaultConfig;
        }
    }
    return defaultConfig;
};

export const getAge = (dateOfBirth: string, toDate: Date): number => {
    const dob = convertToDate(dateOfBirth);
    const departure = convertToDate(getShortDate(convertToDate(toDate)));
    return getDifferenceInYears(dob, departure);
};
